<script lang="ts">
	import { twMerge } from 'tailwind-merge';
	import { Link } from '$global/components/Link';
	import { Txt } from '$global/components/Txt';

	interface Props {
		href: string;
		class?: string;
	}

	let { href, ...rest }: Props = $props();
</script>

<Txt
	variant="body3"
	class={twMerge(
		'mx-auto mt-4 max-w-[27.5rem] text-center leading-[1.25rem] text-gray-500',
		rest.class
	)}
>
	Any personal data you submit will be processed in accordance with our <Link
		class="underline"
		target="_blank"
		rel="noopener noreferrer"
		{href}
	>
		Privacy Policy.
	</Link>
</Txt>
